// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"27":"BuyerLazyComponent","46":"BadgeTooltipV1","795":"IntroVideoModal"}[chunkId] + "." + {"27":"69d9c4979d8ce8fb0605","46":"e20c5a7ef4c5e717c679","795":"3187f4047e5c8023c709"}[chunkId] + ".js";
};